//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        name: 'base_info_header',
        props:{
            maternalId:{
                type: String,
                required: false
            },
            otherFormDetail:{
                type: String,
                required: false
            }
        },
        data (){
            return {
                baseInfo:{
                    name: '',
                    liveTime: '',
                    room_name: '',
                    phone: '',
                    package: '',
                    ready_leave_date: '',
                    birth_type_val: '',
                    birth_type_arr: [
                        {
                            label: '顺产',
                            value: 1
                        },{
                            label: '剖腹产',
                            value: 2
                        },{
                            label: '流产',
                            value: 3
                        },{
                            label: '不知道',
                            value: 0
                        },
                    ]
                },
            }
        },
        methods: {
            //时间戳转日期格式    
            formatDateTime(inputTime) {  
                var date = new Date(parseInt(inputTime)*1000)
                var y = date.getFullYear() 
                var m = date.getMonth() + 1  
                m = m < 10 ? ('0' + m) : m; 
                var d = date.getDate()
                d = d < 10 ? ('0' + d) : d
                var h = date.getHours()
                h = h < 10 ? ('0' + h) : h
                var minute = date.getMinutes()
                var second = date.getSeconds()
                minute = minute < 10 ? ('0' + minute) : minute 
                second = second < 10 ? ('0' + second) : second
                return y + '年' + m + '月' + d + '日'
            },
            //请求用户基本信息
            apiMemberInfo(){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.maternalId
                }
                Api.checkRoomApi.memberInfo(params).then ( res => {
                    if(res.errcode == 1){
                        let birth_type = ''
                        for(let item of this.baseInfo.birth_type_arr){
                            if(item.value == res.data.birth_type){
                                birth_type = item.label
                            }
                        }
                        this.baseInfo.name = res.data.name
                        this.baseInfo.phone = res.data.phone
                        this.baseInfo.package = res.data.package_name
                        this.baseInfo.liveTime =this.formatDateTime(res.data.live_time)
                        this.baseInfo.room_name = res.data.room_name
                        this.baseInfo.ready_leave_date = this.formatDateTime(res.data.ready_leave_date)
                        this.baseInfo.birth_type_val = birth_type
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            }
        },
        created(){
            this.apiMemberInfo()
        }
    }



// WEBPACK FOOTER //
// ./src/components/base_info_header.vue